(function () {
  /* Search interaction tracking */
  function waitForElement(selector, callback) {
    var el = document.querySelector(selector);
    if (el) return callback(el);
    var observer = new MutationObserver(function () {
      var found = document.querySelector(selector);
      if (found) {
        callback(found);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function markSearchInteraction() {
    localStorage.setItem('cp_search_interacted', '1');
  }

  waitForElement('#cp09v2-popup-input', function (searchInput) {
    searchInput.addEventListener('input', function () {
      if (this.value.trim().length > 0) markSearchInteraction();
    });
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && this.value.trim().length > 0) markSearchInteraction();
    });
  });

  var currentUrl = window.location.href;
  var searchUsed = localStorage.getItem('cp_search_interacted');

  if (/\/products\/[^\/]+$/.test(currentUrl) && searchUsed === '1') {
    window.VWO = window.VWO || [];
    window.VWO.event =
      window.VWO.event ||
      function () {
        window.VWO.push(['event'].concat([].slice.call(arguments)));
      };
    window.VWO.event('searchInteractedThenPdpViewed');
    localStorage.removeItem('cp_search_interacted');
  }
})();

/* ---- Main CRO ---- */
(function () {
  'use strict';

  if (window.__CP09v2__) return;
  window.__CP09v2__ = true;

  /* Merge settings from Liquid */
  var _cfg = window.CP09v2Config || {};

  var CFG = {
    collectionHandle: _cfg.collectionHandle || 'all',
    maxProducts: _cfg.maxProducts || 7,
    debounceMs: 260,
    phIntervalMs: 5000,
    placeholders: _cfg.placeholders && _cfg.placeholders.length
      ? _cfg.placeholders
      : [
          'Search for Bento Jot',
          'Search for Laptop Bags',
          'Search for Desk Accessories',
          'Search for Office Backpacks',
        ],
  };

  function debounce(fn, ms) {
    var t;
    return function () {
      var a = arguments, c = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(c, a); }, ms);
    };
  }

  function escapeHTML(s) {
    if (!s) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function onReady(selector, cb, timeoutMs) {
    var el = document.querySelector(selector);
    if (el) { cb(el); return function () {}; }
    var obs = new MutationObserver(function () {
      var f = document.querySelector(selector);
      if (f) { obs.disconnect(); clearTimeout(t); cb(f); }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    var t = setTimeout(function () { obs.disconnect(); }, timeoutMs || 8000);
    return function () { obs.disconnect(); clearTimeout(t); };
  }

  function safeLS(op, k, v) {
    try {
      if (op === 'get') return localStorage.getItem(k);
      if (op === 'set') localStorage.setItem(k, v);
      if (op === 'del') localStorage.removeItem(k);
    } catch (e) {}
    return null;
  }

  function safeSS(op, k, v) {
    try {
      if (op === 'get') return sessionStorage.getItem(k);
      if (op === 'set') sessionStorage.setItem(k, v);
      if (op === 'del') sessionStorage.removeItem(k);
    } catch (e) {}
    return null;
  }

  var SVG = {
    search:
      '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" ' +
      'xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<circle cx="7.9" cy="7.9" r="6.98" stroke="currentColor" stroke-width="1.85"></circle>' +
      '<path d="M12.9 13.27L18.86 18.71" stroke="currentColor" ' +
      'stroke-width="1.62" stroke-linecap="round"></path></svg>',
    closeInBar:
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" ' +
      'xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M18 6L6 18M6 6l12 12" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round"></path></svg>',
  };

  var S = {
    open: false,
    typedFired: false,
    lastQuery: '',
    popularFetched: false,
    popularHTML: '',
    phIdx: 0,
    phTimer: null,
    ctrl: null,
  };

  function fmtINR(p) {
    return '\u20B9' + parseFloat(p).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function imgURL(raw) {
    if (!raw) return '';
    return raw.replace(/(\.[^.?]+)(\?.*)?$/, '_320x$1$2');
  }

  function buildCard(title, handle, src, price) {
    var imgTag = src
      ? '<img class="cp09v2-card__img" src="' + src + '" alt="' + escapeHTML(title) + '" loading="lazy" width="160" height="200">'
      : '<div class="cp09v2-card__img cp09v2-card__img--empty"></div>';
    return (
      '<a class="cp09v2-card" href="/products/' + escapeHTML(handle) + '">' +
      '<div class="cp09v2-card__thumb">' + imgTag + '</div>' +
      '<p class="cp09v2-card__name">' + escapeHTML(title) + '</p>' +
      (price ? '<p class="cp09v2-card__price">' + fmtINR(price) + '</p>' : '') +
      '</a>'
    );
  }

  function buildPopularHTML(prods) {
    var cards = prods.slice(0, CFG.maxProducts).map(function (p) {
      var v = p.variants && p.variants[0];
      var src = imgURL(p.images && p.images[0] && p.images[0].src);
      return buildCard(p.title, p.handle, src, v ? v.price : '');
    }).join('');
    return '<p class="cp09v2-panel-label">Popular Products</p><div class="cp09v2-cards">' + cards + '</div>';
  }

  function buildResultsHTML(prods) {
    if (!prods || !prods.length) return '';
    var cards = prods.slice(0, CFG.maxProducts).map(function (p) {
      var src = imgURL(p.featured_image && p.featured_image.url);
      return buildCard(p.title, p.handle, src, p.price || '');
    }).join('');
    return '<p class="cp09v2-panel-label">Products</p><div class="cp09v2-cards">' + cards + '</div>';
  }

  function buildSkeletons(n) {
    var h = '';
    for (var i = 0; i < n; i++) {
      h +=
        '<div class="cp09v2-card cp09v2-card--skel">' +
        '<div class="cp09v2-card__thumb cp09v2-skel"></div>' +
        '<div class="cp09v2-skel cp09v2-skel--name"></div>' +
        '<div class="cp09v2-skel cp09v2-skel--price"></div>' +
        '</div>';
    }
    return h;
  }

  function fetchPopular() {
    return fetch('/collections/' + CFG.collectionHandle + '/products.json?limit=' + CFG.maxProducts + '&sort_by=best-selling')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return Array.isArray(d.products) ? d.products : []; })
      .catch(function () { return []; });
  }

  function fetchPredictive(q) {
    if (S.ctrl) { try { S.ctrl.abort(); } catch (e) {} }
    if (window.AbortController) S.ctrl = new AbortController();
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + CFG.maxProducts;
    return fetch(url, S.ctrl ? { signal: S.ctrl.signal } : {})
      .then(function (r) { return r.ok ? r.json() : { resources: { results: {} } }; })
      .then(function (d) { return d.resources && d.resources.results ? d.resources.results : {}; })
      .catch(function (err) { return err && err.name === 'AbortError' ? null : {}; });
  }

  function createPill() {
    var pill = document.createElement('div');
    pill.className = 'cp09v2-pill';
    pill.id = 'cp09v2-pill';
    pill.setAttribute('role', 'button');
    pill.setAttribute('tabindex', '0');
    pill.setAttribute('aria-label', 'Open search');
    pill.innerHTML =
      '<span class="cp09v2-pill__icon">' + SVG.search + '</span>' +
      '<span class="cp09v2-pill__placeholder" id="cp09v2-pill-ph">' + CFG.placeholders[0] + '</span>';
    return pill;
  }

  function startPillRotation() {
    var el = document.getElementById('cp09v2-pill-ph');
    if (!el) return;
    S.phTimer = setInterval(function () {
      if (S.open) return;
      el.classList.add('cp09v2-pill__placeholder--fade');
      setTimeout(function () {
        S.phIdx = (S.phIdx + 1) % CFG.placeholders.length;
        el.textContent = CFG.placeholders[S.phIdx];
        el.classList.remove('cp09v2-pill__placeholder--fade');
      }, 220);
    }, CFG.phIntervalMs);
  }

  function createPopup() {
    var el = document.createElement('div');
    el.className = 'cp09v2-popup';
    el.id = 'cp09v2-popup';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Search');
    el.innerHTML =
      '<div class="cp09v2-popup__bar">' +
      '<div class="cp09v2-popup__form">' +
      '<span class="cp09v2-popup__search-icon">' + SVG.search + '</span>' +
      '<input id="cp09v2-popup-input" class="cp09v2-popup__input" type="search"' +
      ' autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false"' +
      ' placeholder="Search" aria-label="Search products">' +
      '<button id="cp09v2-popup-close" class="cp09v2-popup__close" type="button" aria-label="Close search">' +
      SVG.closeInBar + '</button>' +
      '</div></div>' +
      '<div class="cp09v2-popup__panel">' +
      '<div id="cp09v2-popup-inner" class="cp09v2-popup__inner">' +
      '<p class="cp09v2-panel-label">Popular Products</p>' +
      '<div class="cp09v2-cards">' + buildSkeletons(CFG.maxProducts) + '</div>' +
      '</div></div>';
    return el;
  }

  var _popup, _backdrop, _input, _closeBtn, _inner;

  function syncHeaderBottom() {
    var selectors = ['.header', 'theme-header#header', 'theme-header', '.site-header', 'header'];
    var bottom = 0;
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) { bottom = Math.round(el.getBoundingClientRect().bottom); break; }
    }
    document.documentElement.style.setProperty('--cp09-header-bottom', Math.max(0, bottom) + 'px');
  }

  function openPopup() {
    if (S.open) return;
    S.open = true;
    document.body.classList.add('cp09v2-body-open');
    _popup.setAttribute('aria-hidden', 'false');
    _popup.classList.add('cp09v2-popup--open');
    _backdrop.classList.add('cp09v2-backdrop--open');
    _input.value = '';
    showDefault();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { _input.focus(); });
    });
    syncHeaderBottom();
  }

  function closePopup() {
    if (!S.open) return;
    S.open = false;
    document.body.classList.remove('cp09v2-body-open');
    _popup.setAttribute('aria-hidden', 'true');
    _popup.classList.remove('cp09v2-popup--open');
    _backdrop.classList.remove('cp09v2-backdrop--open');
    _input.blur();
  }

  function showDefault() {
    if (S.popularFetched) _inner.innerHTML = S.popularHTML;
  }

  var doPredictive = debounce(function (q) {
    if (!S.open) return;
    if (_input.value.trim() !== q) return;
    fetchPredictive(q).then(function (res) {
      if (!res || !S.open || _input.value.trim() !== q) return;
      if (res.products && res.products.length) {
        _inner.innerHTML = buildResultsHTML(res.products);
      } else {
        _inner.innerHTML = '<p class="cp09v2-no-results">No results found for \u201C' + escapeHTML(q) + '\u201D</p>';
      }
    });
  }, CFG.debounceMs);

  function onInput() {
    var q = _input.value.trim();
    safeLS('set', 'cpintractionWithsearch', '1');
    if (q) safeSS('set', 'vwo_last_action', 'search');
    if (!q) { showDefault(); return; }
    if (!S.typedFired) S.typedFired = true;
    doPredictive(q);
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { closePopup(); return; }
    if (e.key === 'Enter') {
      var q = _input.value.trim();
      if (q.length < 2) { e.preventDefault(); return; }
      S.lastQuery = q;
      window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
    }
  }

  function onCloseBtn() {
    var q = _input.value.trim();
    if (q) { _input.value = ''; _input.focus(); showDefault(); }
    else { closePopup(); }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#AddToCart');
    if (btn && safeSS('get', 'vwo_last_action') === 'search') safeSS('del', 'vwo_last_action');
  });

  (function () {
    if (document.URL.indexOf('order-status') !== -1) {
      if (safeLS('get', 'cpintractionWithsearch') === '1') safeLS('del', 'cpintractionWithsearch');
    }
  })();

  function init() {
    document.body.classList.add('CP_NOOE_09_v2');

    _backdrop = document.createElement('div');
    _backdrop.className = 'cp09v2-backdrop';
    document.body.appendChild(_backdrop);

    _popup = createPopup();
    _popup.setAttribute('aria-hidden', 'true');
    document.body.appendChild(_popup);

    _input = document.getElementById('cp09v2-popup-input');
    _closeBtn = document.getElementById('cp09v2-popup-close');
    _inner = document.getElementById('cp09v2-popup-inner');

    _input.addEventListener('input', onInput);
    _input.addEventListener('keydown', onKeydown);
    _closeBtn.addEventListener('click', onCloseBtn);
    _backdrop.addEventListener('click', closePopup);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && S.open) closePopup();
    });

    onReady('a.thb-secondary-area-item.thb-quick-search', function (anchor) {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openPopup();
      });
      anchor.addEventListener('mousedown', function (e) { e.stopPropagation(); });
      anchor.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          openPopup();
        }
      });

      var pill = createPill();
      anchor.innerHTML = '';
      anchor.appendChild(pill);
      anchor.setAttribute('href', 'javascript:void(0)');
      anchor.setAttribute('role', 'button');
      anchor.setAttribute('aria-label', 'Open search');
      startPillRotation();
    }, 8000);

    fetchPopular().then(function (prods) {
      S.popularFetched = true;
      S.popularHTML = prods.length
        ? buildPopularHTML(prods)
        : '<p class="cp09v2-no-results">No popular products found.</p>';
      if (S.open && !_input.value.trim()) _inner.innerHTML = S.popularHTML;
    });

    syncHeaderBottom();
    window.addEventListener('scroll', debounce(syncHeaderBottom, 40), { passive: true });
    window.addEventListener('resize', debounce(syncHeaderBottom, 80));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();